import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

import { HOUR_MINUTE_MERIDIEM_FORMAT_STRING, TimeZoneDropdownOptions } from '../constants';

export const getTimeZoneDropdownOptions = () => {
  const date = new Date();

  return TimeZoneDropdownOptions.map((option) => {
    try {
      const meta = format(new TZDate(date, option.value), HOUR_MINUTE_MERIDIEM_FORMAT_STRING).toLowerCase();
      return {
        value: option.value,
        label: option.label,
        meta,
      };
    } catch (error) {
      return {
        value: option.value,
        label: option.label,
      };
    }
  });
};
